import React from 'react';
export function WhatYouReceive() {
  const tomos = [{
    block: 'FÍSICO-QUÍMICA — 3 TOMOS',
    subtitle: 'Para docentes de 2do y 3ro año de secundaria',
    items: [{
      number: 1,
      title: 'Tomo 1 — 2do Año',
      subtitle: 'La Materia y sus Propiedades',
      description: 'Propiedades, densidad, mezclas, métodos de separación y cambios físico-químicos.'
    }, {
      number: 2,
      title: 'Tomo 2 — 2do Año',
      subtitle: 'El Modelo Atómico y la Tabla Periódica',
      description: 'Evolución atómica, partículas subatómicas, configuración electrónica y familias.'
    }, {
      number: 3,
      title: 'Tomo 3 — 2do/3ro Año',
      subtitle: 'Estados de la Materia y Cambios de Estado',
      description: 'Sólidos, líquidos y gases. Curvas de calentamiento y puntos de fusión y ebullición.'
    }]
  }, {
    block: 'FÍSICO-QUÍMICA — 3 TOMOS',
    subtitle: 'Para docentes de 3ro año de secundaria',
    items: [{
      number: 4,
      title: 'Tomo 4 — 3ro Año',
      subtitle: 'Estructura de la Materia y Uniones Químicas',
      description: 'Regla del octeto, enlace iónico, covalente, estructuras de Lewis y polaridad.'
    }, {
      number: 5,
      title: 'Tomo 5 — 3ro Año',
      subtitle: 'Reacciones Químicas y Nomenclatura',
      description: 'Tipos de reacciones, ajuste por tanteo, nomenclatura IUPAC y estequiometría básica.'
    }, {
      number: 6,
      title: 'Tomo 6 — 3ro Año',
      subtitle: 'Fenómenos Eléctricos y Magnéticos',
      description: 'Carga eléctrica, circuitos básicos, magnetismo e inducción electromagnética.'
    }]
  }, {
    block: 'FÍSICA — 3 TOMOS',
    subtitle: 'Para docentes de 4to y 5to año de secundaria',
    items: [{
      number: 7,
      title: 'Tomo 7 — 4to/5to Año',
      subtitle: 'Cinemática: El Movimiento',
      description: 'MRU, MRUV, caída libre, gráficos posición-tiempo y velocidad-tiempo.'
    }, {
      number: 8,
      title: 'Tomo 8 — 4to/5to Año',
      subtitle: 'Dinámica y Leyes de Newton',
      description: 'Las 3 leyes, diagramas de fuerzas, peso, normal, tensión y rozamiento.'
    }, {
      number: 9,
      title: 'Tomo 9 — 4to/5to Año',
      subtitle: 'Energía, Trabajo y Potencia',
      description: 'Trabajo mecánico, energía cinética y potencial, conservación y potencia.'
    }]
  }, {
    block: 'QUÍMICA — 3 TOMOS',
    subtitle: 'Para docentes de 4to y 5to año de secundaria',
    items: [{
      number: 10,
      title: 'Tomo 10 — 4to/5to Año',
      subtitle: 'Soluciones y Estequiometría',
      description: 'Concentración, molaridad, diluciones y cálculos estequiométricos completos.'
    }, {
      number: 11,
      title: 'Tomo 11 — 4to/5to Año',
      subtitle: 'Química Orgánica e Hidrocarburos',
      description: 'Alcanos, alquenos, alquinos, isómeros, grupos funcionales y petróleo.'
    }, {
      number: 12,
      title: 'Tomo 12 — 4to/5to Año',
      subtitle: 'Biomoléculas y Química del Carbono',
      description: 'Hidratos de carbono, lípidos, proteínas y ácidos nucleicos ADN/ARN.'
    }]
  }];
  const includes = ['15 ejercicios listos para imprimir y entregar', 'Consignas claras que el alumno entiende solo', 'Diseño optimizado para fotocopiadora', 'Solucionario docente completo', 'Secuencia didáctica con objetivos', 'Imágenes y diagramas ilustrativos'];
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-268">
      <div className="max-w-4xl mx-auto" data-id="element-269">
        <h2 className="text-2xl md:text-3xl font-bold text-carbon text-center mb-12" data-id="element-270">
          Lo que recibís:
        </h2>

        {tomos.map((block, blockIndex) => <div key={blockIndex} className="mb-12" data-id="element-271">
            <div className="mb-6" data-id="element-272">
              <div className="text-sci-orange font-bold text-lg mb-1" data-id="element-273">
                {block.block}
              </div>
              <div className="text-gray-600 text-sm" data-id="element-274">{block.subtitle}</div>
            </div>

            <div className="space-y-6" data-id="element-275">
              {block.items.map(tomo => <div key={tomo.number} className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-276">
                  <div className="flex gap-4" data-id="element-277">
                    <div className="w-12 h-12 bg-sci-orange rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0" data-id="element-278">
                      {tomo.number}
                    </div>
                    <div className="flex-1" data-id="element-279">
                      <h3 className="font-bold text-carbon text-lg mb-1" data-id="element-280">
                        {tomo.title}
                      </h3>
                      <h4 className="text-sci-orange font-semibold text-sm mb-2" data-id="element-281">
                        {tomo.subtitle}
                      </h4>
                      <p className="text-gray-700 text-sm" data-id="element-282">
                        {tomo.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>)}

        {/* What each tomo includes */}
        <div className="bg-gray-100 p-8 rounded-lg mt-12" data-id="element-283">
          <h3 className="text-xl font-bold text-carbon text-center mb-6" data-id="element-284">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-285">
            {includes.map((item, i) => <div key={i} className="flex gap-2 items-start" data-id="element-286">
                <span className="text-bio-green flex-shrink-0" data-id="element-287">✅</span>
                <span className="text-gray-700 text-sm" data-id="element-288">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}